import { createScopedDescriptor } from 'quartz/globalState/api';
import { getBuildTimePropertyNames } from 'quartz/globalState/initialize';
// Properties initialized in quartz/globalState/initialize.ts
export const COPILOT_LAYOUT_TYPE = createScopedDescriptor(getBuildTimePropertyNames().copilotLayoutType, 'BROWSING_CONTEXT');